import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormateService {

  constructor(private datePipe: DatePipe) { }

  yearMonthDate(date){
    if(date) {
      return this.datePipe.transform(date, 'yyyy-MM-dd');
    }
  }
  formateDate(data){
    if(data) {
      return this.yearMonthDate(new Date(data.year, data.month -1, data.day));
    }
  }
}
